export const SOFTLINE_API_SCAN_PALETTE = "/v1/lagerplatzinhalt/scan-palette/{{code}}";
export const SOFTLINE_API_SCAN_LAGERPLATZ = "/v1/lagerplatz/scan/{{code}}";
export const SOFTLINE_API_UMLAGERUNG = '/v1/umlagerung';
